export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14825.4ecb1b9b.jpg";